<template>
    <div class="container mt-5">
 <div>
    <h1>
      <b-icon icon="people-fill"></b-icon> Academic Plan

       <div class="float-right" style="margin-top: -62px;"> <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button> 
       </div>
         <help id="15" />
    </h1>

    </div>

 <div class="row">
                <b-card  class="col-md-12 col-sm-12 select mb-5" border-variant="primary" sm="12"  v-if="empty">
   No Data
   </b-card>
      <div class="text-center w-100" v-if="isLoadingData ">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
       <div class="row" v-else>
        
           <b-card  class="col-md-12 ml-3 col-sm-12 select mb-5" border-variant="primary" sm="12" >
           <h2 v-if="AcademicPlan.length > 0">Current Specialization:<span class="text-warning"> {{AcademicPlan[0].SpecializationNameEN}}</span></h2>
         </b-card>


<b-col sm="12" md="12">


<!-- <b-card  class="col-md-4 col-sm-12 select" border-variant="primary" sm="12"  v-if="empty">
   No Data
   </b-card> -->
  <div class="col-md-12" v-for = "(level , index) in levels" v-bind:key="index">

<div class="accordion col-md-12" role="tablist">

     <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle="'accordion-productdetails'+index" variant="info" class="text-left" v-b-tooltip.hover title="level">{{level}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-productdetails'+index" visible  :accordion="'productdetails-accordion'+index" role="tabpanel">
        <b-card-body>
        
          <div>   
<div class="row">
        <div class="col-md-4 col-sm-12 mb-5"  border-variant="primary"  v-for="item in AcademicPlan.filter(x=>x.LevelName == level)" v-bind:Key="item.LevelName">

                         
                  <div class=" card p-4" :class="item.State == 'Pass' ? 'active2' : item.State == 'Fail' ? 'active' : '' ">
                    <b-card-text><strong>{{item.COURSENAME}}</strong></b-card-text>
                    <div class="text-center">
                      <b-button class="subButton">
                        <span v-if="item.State == 'Pass'" >
                       <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                       </span>
                       <span v-else>
                       <b-icon icon="dash-circle-fill" aria-hidden="true"></b-icon>
                       </span>
                      </b-button>
                      
                      </div>
                      <div class="clearfix"></div>
                      </div>
         
           </div>
 </div>





          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
</div>





 <!-- <h5>{{level}}</h5>
 <div class="row">
        <div class="col-md-4 col-sm-12 mb-5"  border-variant="primary"  v-for="item in AcademicPlan.filter(x=>x.LevelName == level)" v-bind:Key="item.LevelName">

                         
                  <div class=" card p-4" :class="item.State == 'Pass' ? 'active2' : item.State == 'Fail' ? 'active' : '' ">
                    <b-card-text><strong>{{item.COURSENAME}}</strong></b-card-text>
                    <div class="text-center">
                      <b-button class="subButton">
                        <span v-if="item.State == 'Pass'" >
                       <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                       </span>
                       <span v-else>
                       <b-icon icon="dash-circle-fill" aria-hidden="true"></b-icon>
                       </span>
                      </b-button>
                      
                      </div>
                      <div class="clearfix"></div>
                      </div>
         
           </div>
 </div> -->
                <!-- <div v-else-if="item.LevelName == 'Level 2'">
                <h5>Level (2)</h5>
                <div class=" card p-4">
                    <b-card-text><strong>{{item.COURSENAME}}</strong></b-card-text>
                    <div class="text-center">
                      <b-button class="subButton">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                      </b-button>
                      
                      </div>
                      <div class="clearfix"></div>
                </div>



                </div> -->

                <b-card  class="col-md-4 col-sm-12 select" border-variant="primary" sm="12"  v-if="empty">
   No Data
   </b-card>

           </div>
             


  
   



  </b-col>





            <div class="clearfix"></div>

           
          </div>





          
    </div>
 <div class="col-sm-12 text-right mb-5">
              <button class="btn btn-primary" @click="()=>$router.push('/Adviser')">Back to Advisor</button>
            </div>




</div>
</template>


<script>
    import studentData from '../../../services/student/studentDataServices';
import Help from '../../Help.vue';
    export default {
  components: { Help },
        name: 'AcademicPlan',
        data(){
            return{
                AcademicPlan: [], 
                message:'',
                isLoading : true,
                levels:[],
                Advdata : {},
                comp :[],
                empty : true,
                 isLoadingData : true
            }
        }, computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },
       mounted(){
         //this.currenUser.StudentID
           studentData.GetStudentState(this.currenUser.StudentID,0,0).then(Response =>{
               this.isLoading = false ;
               if (Response.data.length == 0){
                 this.empty = true
                 return true
                
               }
               this.AcademicPlan = Response.data
                this.levels = this.AcademicPlan.map(item=> item.LevelName)
                this.levels = [...new Set(this.levels)]
                this.empty = false
                 this.isLoadingData = false
                // eslint-disable-next-line no-console
                  // console.log('StudentState => ', )
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                  this.empty = true
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
       },
       

    };
</script>













<style >
.help{
  color: #fff;
    background-color: #ff8600;
  
}
.row{
  width : 100%
}
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}

h2{
    color: #285475;
    font-size: 25px;
    
    padding: 10px 0px;
}
h1 a {
    color: #ff8600;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

.subButton{
  margin-bottom: -50px;
    width: 50%;
    background: #285476;
    text-align: center;
    border: 0px;
}
.card-deck{
  width: 100%  !important;
}

.active2 {
    color: #fff !important;    
    background-color: #007bff !important;
  }

  /* .active2 button .bi-dash-circle-fill::before { 
     content: "\F2E5" !important;
      }

   */

  .active{
    background-color: rgba(0, 0, 0, 0.03);
    color:#333
  }

  @media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

.btn-info {
    color: #fff;
    background-color: #eef6fb;
    border-color: rgb(178 188 198 / 25%);
    color: #1E5B8B !important;
    padding: 1em 2em !important;
    text-align: left;
    width: 100%;
    font-weight: 800;
}

.btn-info:hover {
    color: #fff !important;
    background-color: #285475;
    border-color: #204866;
}

.btn-info.focus, .btn-info:focus {
 color: #1E5B8B !important;
    background-color: #eef6fb;
    border-color: #204866;
}

.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #285475;
    border-color: #204866;
}
.show{
  display:block;
}

</style>